import React, { useCallback } from 'react';

// import URL from 'url';

import Grid from '@mui/material/Grid';
import { withStyles } from "@mui/styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import classnames from "classnames";
import defaultMetadata from "../../defaultMetadata";
import { useTheme, withTheme } from '@emotion/react';
import UpcomingEvents from "./upcoming_events.jsx";
import story1 from '../../assets/alumni_stories/story_1.png'
import story2 from '../../assets/alumni_stories/story_2.png'
import story3 from '../../assets/alumni_stories/story_3.png'
import WhatsImage from "../../assets/whats_happening.png";
import biopharma from '../../assets/about_syneos/biopharma.png'
import collaboration from '../../assets/about_syneos/collaboration.png'
import AlumniSpotlight from './AlumniSpotlight'
import memory1 from '../../assets/memories/1.png'
import memory2 from '../../assets/memories/2.png'
import memory3 from '../../assets/memories/3.png'


const DropItem = () => <></>

const styles = (theme) =>{
    return {
        whatsContainer: {
            width: "100%",
            position: "relative",
        },
        whatsImage:{
            width: '100%',
            height: 340,
            borderBottom: `16px solid ${theme.palette.primary.main}`
        },
        whatsContent: {
            position: 'absolute',
            top: 64,
            left: 92,
            right: 92,
            maxWidth: '1100px',
            margin: 'auto'
        },
        aboutContent: {
            position: 'absolute',
            top: 40,
            left: 40,
            right: 40,
            bottom: 40,
            margin: 'auto'
        },
        button:{
            padding: '18px 35px',
            color: 'white',
            border: '1px solid white',
            boxSizing: 'border-box',
            transition: 'all 400ms ease',
            borderRadius: '4px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            width: '160px',
            height: '48px',
            "&:hover":{
                backgroundColor: '#EB3300',
                borderColor: '#EB3300',
            }
        },
        memoryTitle:{
            color: theme.palette.primary.main
        }
    }
};


const About = (props) => {
    const theme = useTheme();

    const alumni_stories = () => {
        return (
            <div className="margin-80-auto-24 max-width-1100 padding-0-24">
                <div className="default_flex_container justify-content-space-between">
                    <div className="text_title font-size-32 font-weight-800">
                        Alumni Stories
                    </div>
                    <div className="text_subtitle_big color-primary">
                    <span className="vertical-align-middle margin-right-2">
                        See All
                    </span>
                    <ArrowForwardIcon className="vertical-align-middle width-20px"/>
                    </div>
                </div>
                <div className="text_title_small padding-top-16">Inspirational series our alumni share, in their own words.</div>
                <div className="display-grid grid-3-columns padding-top-24">
                    <div className="story_box">
                        <img className="story_image" src={story1} alt="logo" />
                        <div className="text_title_small">In search of the world's most magnificent mountaineering – Charles Sherwood</div>
                        <div className="text_body">In her mission for more equitable health care, Dr. Marshala Lee MD'11 is using every tool..</div>
                        <div className="text_body_link padding-top-12 color-eb3300 font-weight-bold">Read more</div>
                    </div>
                    <div className="story_box">
                        <img className="story_image" src={story2} alt="logo" />
                        <div className="text_title_small">Health care and haircuts: Bringing preventative measures to the neighborhood</div>
                        <div className="text_body">In her mission for more equitable health care, Dr. Marshala Lee MD'11 is using every tool..</div>
                        <div className="text_body_link padding-top-12 color-eb3300 font-weight-bold">Read more</div>
                    </div>
                    <div className="story_box">
                        <img className="story_image" src={story3} alt="logo" />
                        <div className="text_title_small">A passion for learning</div>
                        <div className="text_body">Alexandros Pamnani shares how he went from dropping out of school to working fo..</div>
                        <div className="text_body_link padding-top-12 color-eb3300 font-weight-bold">Read more</div>
                    </div>
                </div>
            </div>
        );
    }

    const memories = () => {
        return (
            <div className="background-3a3f42">
                <div className="padding-50-24 max-width-1100 margin-auto">
                    <div className="default_flex_container justify-content-space-between">
                        <div className={classes.memoryTitle+' text_super_big_title'}>
                            Recent Memories
                        </div>
                        <div className="text_subtitle_big color-primary">
                            <span className="vertical-align-middle margin-right-2">
                                See All
                            </span>
                            <ArrowForwardIcon className="vertical-align-middle width-20px"/>
                        </div>
                    </div>
                    <div className="display-grid grid-3-columns margin-top-16">
                        <div>
                            <img
                                className="img-full-width"
                                src={memory1}
                                alt="image"
                            />
                            <div className="text_title_small color-white margin-top-16">Alumni Re-union '20</div>
                        </div>
                        <div>
                            <img
                                className="img-full-width"
                                src={memory2}
                                alt="image"
                            />
                            <div className="text_title_small color-white margin-top-16">DIA '18</div>
                        </div>
                        <div>
                            <img
                                className="img-full-width"
                                src={memory3}
                                alt="image"
                            />
                            <div className="text_title_small color-white margin-top-16">Regional meetup</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const whats_happening = () => {
        return (
            <div className={classes.whatsContainer}>
                <img
                    className={classes.whatsImage}
                    src={WhatsImage}
                    alt="image"
                />
                <div className={classes.whatsContent}>
                    <div className="default_flex_container justify-content-space-between">
                        <div className="text_super_big_title color-white">What's happening <span className="font-weight-500">at Syneos</span></div>
                        <div className="text_subtitle_big color-white">
                            <span className="vertical-align-middle margin-right-2 text-decoration-underline">
                                Discover Syneos Health
                            </span>
                        </div>
                    </div>
                    <div className="display-grid grid-3-columns padding-top-24">
                        <div>
                            <div className="text_title color-white">Syneos Health and Aetion Partner to Offer RWE Solutions to Advance Drug Development and Commercialization</div>
                            <div className="text_subtitle_big color-white margin-top-16 text-decoration-underline">
                                <span className="vertical-align-middle margin-right-2">Read the News</span>
                                <ArrowForwardIcon className="vertical-align-middle width-20px"/>
                            </div>
                        </div>
                        <div>
                            <div className="text_title color-white">Ukraine Conflict Resource Center</div>
                            <div className="text_subtitle_big color-white margin-top-16 text-decoration-underline">
                                <span className="vertical-align-middle margin-right-2">Visit the Resource center</span>
                                <ArrowForwardIcon className="vertical-align-middle width-20px"/>
                            </div>
                        </div>
                        <div>
                            <div className="text_title color-white">Syneos Health Colleagues Choose to Challenge Gender Disparity on International Women's Day and Beyond</div>
                            <div className="text_subtitle_big color-white margin-top-16 text-decoration-underline">
                                <span className="vertical-align-middle margin-right-2">Watch the Video</span>
                                <ArrowForwardIcon className="vertical-align-middle width-20px"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const about_inst = () => {
        return(
            <div className="margin-80-auto-24 max-width-1100 padding-0-24">
                <div className="text_super_big_title color-primary">About Syneos</div>
                <div className="display-grid grid-2-columns padding-top-24">
                    <div className={classes.whatsContainer}>
                        <img
                            className="img-full-width"
                            src={biopharma}
                            alt="image"
                        />
                        <div className={classes.aboutContent}>
                            <div className="text_super_big_title color-white">Biopharmaceutical Acceleration Model®</div>
                            <div className="text_title_small color-white padding-top-16">At Syneos Health, clinical and commercial live under the same roof and constantly share real world knowledge and insights that lead to getting the job done better, smarter and faster. </div>
                            <div className={classes.button + ' margin-top-48'}>Learn More</div>
                        </div>
                    </div>
                    <div className={classes.whatsContainer}>
                        <img
                            className="img-full-width"
                            src={collaboration}
                            alt="image"
                        />
                        <div className={classes.aboutContent}>
                            <div className="text_super_big_title color-white">Syneos Collaborations</div>
                            <div className="text_title_small color-white padding-top-16">At Syneos Health, clinical and commercial live under the same roof and constantly share real world knowledge and insights that lead to getting the job done better, smarter and faster. </div>
                            <div className={classes.button + ' margin-top-94'}>Learn More</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const {classes} = props;
    return (
        <div>
            {/* <div className="contentContainer">
                <div className="padding-12">
                    <Grid container spacing={2} justifyContent="space-between" className="padding-44-0">
                        <Grid item sm={12} md={6} >
                            <AlumniSpotlight metadata={defaultMetadata}/>
                        </Grid>
                        <Grid item sm={12} md={6} >
                            <UpcomingEvents metadata={defaultMetadata} className="height-100" />
                        </Grid>
                    </Grid>
                </div>
            </div>
            <div className="max-width-634 border-1px-eb3300 margin-auto"></div>
            <div>{alumni_stories()}</div>
            <div>{memories()}</div>
            <div>{whats_happening()}</div> */}
            <div>{about_inst()}</div>
        </div>
    );

}

export default withStyles(styles, {withTheme: true})(withTheme((About)));